import React, { Component } from 'react';
import Button from '../../../components/button/Button';
import Toast from '../../../components/toast/Toast';
import { quitShutdownMode } from '../../../service/command';

export default class QuitShutdown extends Component {
  onConfirm() {
    const loading = Toast.loading('正在退出低电模式');

    quitShutdownMode('quit shutdown').then(() => {
      this.props.closePanel();
      Toast.success('退出成功');
    }).catch((error) => {
      Toast.fail(error);
    }).then(() => {
      loading.destroy();
    });
  }

  render() {
    return (
      <div>
        <div style={{ textAlign: 'center', margin: '10px' }}>是否退出低电模式</div>
        <div style={{ textAlign: 'center' }}>
          <Button type="primary" onClick={() => this.onConfirm()}>确认退出</Button>
        </div>
      </div>
    );
  }
}
